import { Box, Skeleton, Stack, styled } from "@mui/material";
import dashboardAPI, { MultipleResultResponse } from "apis/DashboardAPI";
import FlexBox from "components/FlexBox";
import { H3, H6 } from "components/Typography";
import ScheduleIcon from "icons/sidebar/ScheduleIcon";
import { FC, useEffect, useState } from "react";

const NAMES = [
  "Vagas abertas Hoje",
  "Vagas abertas amanhã",
  "Vagas abertas Semana",
];
const VALUES = [0, 1, 2];

const IconWrapper = styled(Box)<{ color?: string }>(({ theme, color }) => ({
  width: 40,
  height: 40,
  color: "white",
  display: "flex",
  borderRadius: "4px",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: color ? color : theme.palette.primary.main,
}));

const FollowWrapper = styled(Box)(() => ({
  width: "100%",
  maxWidth: 760,
  margin: "0 auto",
  paddingTop: 32,
  paddingBottom: 32,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 18,
  flexWrap: "wrap",
}));

const statusIconColors = [undefined, "#1ABC9C", "#FF9777"] as const;

const StatusSkeleton = () => (
  <FollowWrapper>
    {NAMES.map((name, index) => (
      <FlexBox alignItems="center" key={name}>
        <Skeleton
          variant="rounded"
          width={40}
          height={40}
          sx={{ borderRadius: "4px", flexShrink: 0 }}
        />
        <Stack spacing={0.45} ml={1.5}>
          <Skeleton
            variant="text"
            sx={{ fontSize: 13, lineHeight: 1, width: index === 2 ? 120 : 112 }}
          />
          <Skeleton
            variant="text"
            sx={{ fontSize: 24, lineHeight: 1, width: 28 }}
          />
        </Stack>
      </FlexBox>
    ))}
  </FollowWrapper>
);

const ScheduleStatus: FC = () => {
  const [valueQuantity, setValueQuantity] =
    useState<MultipleResultResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    void loadStatusData();
  }, []);

  async function loadStatusData(): Promise<void> {
    try {
      const response = await dashboardAPI.getWeekScheduleAvailability();
      const result = response.data as MultipleResultResponse;
      if (result) {
        setValueQuantity(result);
      }
    } catch (error) {
      console.error("Erro ao carregar os dados:", error);
    } finally {
      setIsLoading(false);
    }
  }

  const getMetricValue = (index: number): string => {
    if (!valueQuantity?.values?.[index]) return "0";
    return valueQuantity.values[index];
  };

  if (isLoading) return <StatusSkeleton />;
  if (!valueQuantity) return null;

  return (
    <FollowWrapper>
      {NAMES.map((name, index) => (
        <FlexBox alignItems="center" key={name}>
          <IconWrapper color={statusIconColors[index]}>
            <ScheduleIcon fontSize="small" />
          </IconWrapper>
          <Box marginLeft={1.5}>
            <H6 color="text.disabled" lineHeight={1}>
              {name}
            </H6>
            <H3 lineHeight={1} mt={0.6}>
              {getMetricValue(VALUES[index])}
            </H3>
          </Box>
        </FlexBox>
      ))}
    </FollowWrapper>
  );
};

export default ScheduleStatus;
